import React from 'react';
import PropTypes from 'prop-types';
import svgInline from '../../SvgInline/SvgInline';
import withFavorites from './WithFavorites';

import './StatesListItem.css';

export function StatesListItemComponent({ handleClick, state }) {
  // eslint-disable-next-line
  const stateImage = require(`../../Areas/AreasWrapper/images/${state.name}.svg`);

  return (
    <a
      className="states-list-item"
      id={state.name}
      tabIndex="0"
      onClick={() => { handleClick('states', state); }}
    >
      {svgInline(stateImage)}
      <div className="states-list-item-content">
        <span>{state.name}</span>
      </div>
    </a>
  );
}

StatesListItemComponent.propTypes = {
  state: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  handleClick: PropTypes.func.isRequired,
};

export default withFavorites(StatesListItemComponent);



// WEBPACK FOOTER //
// ./src/components/List/Areas/StatesListItem.js